import { proxy } from 'valtio';
import type { AccessCardGeneration } from '../apis/wedding/generate.access.cards';

export type AccessCardTab = "design" | "generate";
export type GenerationStatus = "idle" | "loading" | "success" | "error";

export const accessCardState = proxy({
  // UI State
  activeTab: "design" as AccessCardTab,
  isPreviewOpen: false,

  // Event Selection State
  selectedEvent: null as string | null,
  selectedEventType: null as string | null,

  // Generation State
  generationStatus: "idle" as GenerationStatus,
  generation: null as AccessCardGeneration | null,
  generationError: null as string | null,
  generatedGuestIds: [] as string[],
  
  // Actions
  setActiveTab(tab: AccessCardTab) {
    this.activeTab = tab;
  },
  
  setPreviewOpen(open: boolean) {
    this.isPreviewOpen = open;
  },
  
  setSelectedEvent(eventId: string | null) {
    this.selectedEvent = eventId;
  },
  
  setSelectedEventType(eventType: string | null) {
    this.selectedEventType = eventType;
  },
  
  setSelectedEventWithDetails(eventId: string | null, eventType: string | null) {
    this.selectedEvent = eventId;
    this.selectedEventType = eventType;
  },

  setGenerationStatus(status: GenerationStatus) {
    this.generationStatus = status;
  },

  startGeneration(guestIds: string[]) {
    this.generationStatus = "loading";
    this.generation = null;
    this.generationError = null;
    this.generatedGuestIds = [...guestIds];
  },

  completeGeneration(generation: AccessCardGeneration) {
    this.generationStatus = "success";
    this.generation = generation;
    this.generationError = null;
  },

  failGeneration(message: string) {
    this.generationStatus = "error";
    this.generation = null;
    this.generationError = message;
  },

  resetGenerationStatus() {
    this.generationStatus = "idle";
    this.generationError = null;
  }
});
